export const profileName = (u) => {
  const handle = String(u?.username || '').trim();
  if (handle) return `@${handle}`;
  return String(u?.name || '').trim() || 'Üye';
};

export const needsTelegramBind = (u) => Boolean(u && u.role !== 'admin' && !u.telegram_verified);
